/** How long after the dialog appears its Enter and Escape do nothing. */
export const BALANCE_DIALOG_KEY_PAUSE_MS = 1500;

export interface BalanceDialogEvent {
	type?: string;
	detail?: number;
	repeat?: boolean;
}

/**
 * The dialog can appear while the dispatcher is typing a house number: that
 * Enter was meant for the field below, not for the answer. A mouse click is
 * always an answer. Enter on a focused button arrives as a click with `detail` 0.
 */
export const isBalanceDialogKeyIgnored = (
	event: BalanceDialogEvent | null | undefined,
	shownAt: number,
	now: number = Date.now(),
): boolean => {
	const isKey =
		event?.type === "keydown" ||
		(event?.type === "click" && event.detail === 0);
	if (!isKey) return false;

	return (
		Boolean(event?.repeat) || now - shownAt < BALANCE_DIALOG_KEY_PAUSE_MS
	);
};
